import { loadScript, loadStylesheet } from './assetLoader';

export const injectHorizontalPlayerAssets = async (organisation: string) => {
  const scriptTop = loadScript(window.document);
  const stylesheetTop = loadStylesheet(window.document);
  await Promise.all([
    scriptTop(`https://imasdk.googleapis.com/js/sdkloader/ima3.js`),
    scriptTop(`${__PIXELS_JS_ENDPOINT__}/${organisation}/dual-${organisation}.main.js`),
    stylesheetTop(`${__PIXELS_JS_ENDPOINT__}/${organisation}/dual-${organisation}.main.css`)
  ]);
};
